import {EventInfo} from './event-info.model';

export class TrackingEvent<T> {
  eventInfo: EventInfo;
  eventBody: T;
}
